<template>
<v-dialog :value="true" persistent max-width="350">
  <v-tabs grow v-model="$appData.login_selected_tab">
    <v-tabs-bar class="blue lighten-1">
      <v-tabs-item :href="'#login'" ripple>
        Anmelden
      </v-tabs-item>
      <v-tabs-item :href="'#register'" ripple>
        Registrieren
      </v-tabs-item>
      <v-tabs-slider color="indigo darken-2"></v-tabs-slider>
    </v-tabs-bar>
    <v-tabs-items>
      <v-tabs-content :id="'login'">
        <v-card hover style='background:white'>
          <v-card-text class="pt-4">
            <v-form action='login' submitButtonText="Login">
              <v-text-field label="Benutzername oder E-Mail-Adresse" v-model="$appData.account.username" required></v-text-field>
              <v-text-field label="Passwort" v-model="$appData.account.password" :append-icon="e1 ? 'visibility' : 'visibility_off'" :append-icon-cb="() => (e1 = !e1)" :type="e1 ? 'password' : 'text'" required></v-text-field>
              <v-flex class="pb-2">
                <small>* Eingabe erforderlich</small>
              </v-flex>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="login">Login</v-btn>
          </v-card-actions>
        </v-card>
      </v-tabs-content>
      <v-tabs-content :id="'register'">
        <v-card hover style='background:white'>
          <v-card-text class="pt-4">
            <v-form action='login' submitButtonText="Login">
              <v-text-field label="gewünschter Benutzername" v-model="$appData.account.username" required></v-text-field>
              <v-text-field label="E-Mail-Adresse" v-model="$appData.account.email" required></v-text-field>
              <v-text-field label="gewünschtes Passwort" v-model="$appData.account.password" :append-icon="e1 ? 'visibility' : 'visibility_off'" :append-icon-cb="() => (e1 = !e1)" :type="e1 ? 'password' : 'text'" required></v-text-field>
              Damit wir den Zugang zuordnen können, geben Sie bitte folgende Informationen an:
              <v-text-field label="Name" v-model="$appData.account.name"></v-text-field>
              <v-text-field label="Telefon" v-model="$appData.account.phone"></v-text-field>
              Wenn Sie möchten, können Sie die folgenden Felder ausfüllen. Sollten die Daten mit unserem System übereinstimmen, wird Ihr Zugang automatisch freigeschaltet.
              <v-text-field label="Kundennummer" v-model="$appData.account.customer_nr"></v-text-field>
              <v-text-field label="Rechnungsnummer" v-model="$appData.account.invoice_nr"></v-text-field>
              <v-menu lazy :close-on-content-click="false" v-model="menu" transition="scale-transition" offset-y full-width :nudge-right="40" max-width="290px" min-width="290px">
                <v-text-field label="Rechnungsdatum" v-model="$appData.account.invoice_date" @blur="date = parseDate($appData.account.invoice_date)" slot="activator"></v-text-field>
                <v-date-picker locale="de-DE" v-model="date" @input="$appData.account.invoice_date = formatDate($event)" no-title scrollable actions autosave></v-date-picker>
              </v-menu>
              <v-text-field label="Rechnungsbetrag" v-model="$appData.account.invoice_total"></v-text-field>
              <v-flex class="pb-2">
                <small>* Eingabe erforderlich</small>
              </v-flex>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="register">Jetzt registrieren</v-btn>
          </v-card-actions>
        </v-card>
      </v-tabs-content>
    </v-tabs-items>
  </v-tabs>
</v-dialog>
</template>
<script>
export default {
  data() {
    return {
      e1: true,
      date: null,
      dateFormatted: null,
      menu: null
    }
  },
  created() {
    if (this.$route.query.jwt) {
      this.$api.login({
        jwt: this.$route.query.jwt
      })
      this.$router.push('/')
    }
  },
  methods: {
    login: function(event) {
      this.$api.login({
        username: this.$appData.account.username,
        password: this.$appData.account.password
      })
    },
    register: function(event) {
      this.$api.user.register(this.$appData.account).then((response) => {
        if (response.data && response.data.jwt) {
          this.$api.login({
            jwt: response.data.jwt
          })
        }
      })
    },
    formatDate(date) {
      if (!date) {
        return null
      }

      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    parseDate(date) {
      if (!date) {
        return null
      }

      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// Login.vue?1330f081